var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterSolid = function SvgFilterSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "filter_solid_svg2__a",
    x1: 2.3,
    x2: 153.3,
    y1: 147.3,
    y2: -11.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M76.2 94.5c2.1 2.3 3.3 5.3 3.3 8.4v90.9c0 5.5 6.6 8.3 10.5 4.4l25.4-29.1c3.4-4.1 5.3-6.1 5.3-10.1v-56.1c0-3.1 1.2-6.1 3.3-8.4l72.6-79c5.5-5.9 1.3-15.5-6.8-15.5H10.2C2.1 0-2.1 9.6 3.4 15.5z",
    style: {
      fill: "url(#filter_solid_svg2__a)",
      strokeWidth: 0
    }
  }));
};
export default SvgFilterSolid;